// Constants for selectors
const EMBROIDERY_SELECTOR = '[id*="shopify"][id*="melco"]';
const PERSONALIZATION_SELECTOR =
  'variant-selects input[data-variant*="default-variant"]';
const VARIANT_BUTTON_SELECTOR = '.js-variant-option';
const withOutEmbroideryBtnIndex = 0;
const getEmbroideryElement = () => document.querySelector(EMBROIDERY_SELECTOR);

const toggleEmbroideryOption = (force) => {
  const selectedOption = document.querySelector(
    `${PERSONALIZATION_SELECTOR}:checked`
  );
  if (!selectedOption) return;

  const target = getEmbroideryElement();
  target?.classList.toggle('hidden', force);
};

const updateOptionStyles = () => {
  document
    .querySelectorAll(PERSONALIZATION_SELECTOR)
    ?.forEach((option, index) => {
      option.parentElement.classList.toggle('button-primary', option.checked);
      if (option.checked && index === withOutEmbroideryBtnIndex) {
        toggleEmbroideryOption(true);
      }

      option.parentElement.classList.toggle(
        'button-outline-primary',
        !option.checked
      );
    });
};

const updateVariantButtonHandlers = () => {
  document.querySelectorAll('.js-variant-option')?.forEach((button, index) => {
    button.addEventListener('click', (e) => {
      e.target.querySelector('input')?.click();
      toggleEmbroideryOption(index === withOutEmbroideryBtnIndex);
    });
  });
};

const initEmbroideryToggle = () => {
  updateOptionStyles();
  updateVariantButtonHandlers();
};

// Event Listeners
window.addEventListener('product-info:loaded', initEmbroideryToggle);
window.addEventListener('variant-select:change', () => {
  updateOptionStyles();
  updateVariantButtonHandlers();
});
